import * as types from '../../actions/actionTypes';
import initialState from '../initialState';

export default function datesReducer(state = initialState.analyticsDateRange, action) {
    switch (action.type) {
        case types.LOAD_ANALYTICS_DATE_RANGE_SUCCESS:
            let dates = {...state};
            dates[action.context] = {
                minDate: action.minDate,
                maxDate: action.maxDate,
                fetchedAt: new Date().getTime(),
            };

            return dates;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./web/src/reducers/analytics/datesReducer.js